import { useQuery } from '@tanstack/react-query';

import { janeApiV2 } from '@jane/shared/data-access';
/* eslint-disable-next-line no-restricted-imports */
import type { StoreCategory } from '@jane/shared/models';

const fetchCategories = async (
  retail_org_id?: number
): Promise<StoreCategory[]> => {
  const urlParams = new URLSearchParams();
  retail_org_id &&
    urlParams.append('organization_id', retail_org_id.toString());

  const response = await janeApiV2.get<{ data: StoreCategory[] }>(
    `/business/specials/product_categories?${urlParams.toString()}`
  );
  return response.data;
};
export const useFetchCategories = (enabled: boolean, retail_org_id?: number) =>
  useQuery({
    queryKey: ['product_categories', retail_org_id],
    queryFn: () => fetchCategories(retail_org_id),
    enabled,
  });
